<script>
  import { onMount } from "svelte";
  import { navigate } from "svelte-routing";
  import { auth } from "../../stores/auth.js";
  import api from "../../services/api.js";
  import Logo from "../../components/Logo.svelte";

  let error = null;
  let loading = true;

  onMount(async () => {
    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get("token");
    const errorParam = urlParams.get("error");

    if (errorParam) {
      error = errorParam;
      loading = false;
      return;
    }

    if (token) {
      // Set the token in localStorage
      api.setToken(token);

      try {
        // Fetch user data to check onboarding status
        const user = await api.getCurrentUser();

        // Use full page navigation to ensure auth store properly initializes
        // This avoids race conditions with svelte-routing
        if (!user.alpaca_connected) {
          window.location.href = "/admin/onboarding";
        } else {
          window.location.href = "/admin/dashboard";
        }
      } catch (err) {
        console.error("Error fetching user:", err);
        error = "Failed to fetch user data. Please try again.";
        loading = false;
      }
    } else {
      error = "No authentication token received";
      loading = false;
    }
  });
</script>

<div class="w-full max-w-md">
  <div class="flex flex-col items-center text-center">
    <Logo size={32} />
    {#if loading}
      <p class="text-sm text-ink-secondary mt-6">
        <i class="fas fa-spinner fa-spin text-moira mr-2"></i>
        Signing you in…
      </p>
    {:else if error}
      <div class="banner banner-danger w-full mt-6 text-left">
        {error}
      </div>
      <a href="/auth/login" class="btn btn-outline mt-4">
        Back to sign in
      </a>
    {/if}
  </div>
</div>
